// ** Type Import
import { OwnerStateThemeType } from "../";

const Button = () => {
  return {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState, theme }: OwnerStateThemeType) => ({
          fontWeight: 500,
          borderRadius: 5,
          lineHeight: 1.71,
          letterSpacing: "0.3px",
          ...(ownerState.size === "medium" && ownerState.variant === "text" && {}),
          padding: `${theme.spacing(1.875, 3)}`,
        }),
        contained: ({ ownerState, theme }: OwnerStateThemeType) => ({
          boxShadow: theme.shadows[3],
          padding: `${theme.spacing(1.5, 4)}`,
          fontWeight: "bold",
          color: "white",
          ...(ownerState.color === "primary" && {
            "&:hover": {
              backgroundColor: theme.palette.primary.dark,
            },
          }),
          ...(ownerState.color === "warning" && {
            "&:hover": {
              backgroundColor: theme.palette.warning.dark,
            },
          }),
        }),
        outlined: ({ theme }: OwnerStateThemeType) => ({
          padding: `${theme.spacing(1.5, 4)}`,
        }),
        sizeSmall: ({ ownerState, theme }: OwnerStateThemeType) => ({
          ...(ownerState.variant === "text" && {
            padding: `${theme.spacing(1, 2.25)}`,
          }),
          ...(ownerState.variant === "contained" && {
            padding: `${theme.spacing(1, 2.5)}`,
          }),
          ...(ownerState.variant === "outlined" && {
            padding: `${theme.spacing(0.75, 2.25)}`,
          }),
        }),
        sizeLarge: ({ ownerState, theme }: OwnerStateThemeType) => ({
          ...(ownerState.variant === "text" && {
            padding: `${theme.spacing(2.125, 4.5)}`,
          }),
          ...(ownerState.variant === "contained" && {
            padding: `${theme.spacing(2.125, 5.5)}`,
          }),
          ...(ownerState.variant === "outlined" && {
            padding: `${theme.spacing(1.875, 5.25)}`,
          }),
        }),
      },
    },
  };
};

export default Button;
